import { Head, Link, router } from '@inertiajs/react';
import AppLayout from '@/Layouts/AppLayout';
import Card, { CardBody } from '@/Components/Card';
import Button from '@/Components/Button';
import Badge from '@/Components/Badge';
import Table, { Th, Td, Tr } from '@/Components/Table';
import PageHeader from '@/Components/PageHeader';
import EmptyState from '@/Components/EmptyState';
import Modal, { ModalBody, ModalFooter } from '@/Components/Modal';
import Alert from '@/Components/Alert';
import { useState } from 'react';
import { PlusIcon, PencilSquareIcon, TrashIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

export default function Index({ roles, flash }) {
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const deleteRole = (id) => { router.delete(`/roles/${id}`, { onSuccess: () => setDeleteConfirm(null) }); };

    return (
        <AppLayout>
            <Head title="Roles & Permissions" />
            <PageHeader title="Roles & Permissions" subtitle="Manage access control" actions={<Button href="/roles/create" size="sm"><PlusIcon className="w-4 h-4" /> Create Role</Button>} />
            {flash?.success && <Alert type="success" className="mb-4">{flash.success}</Alert>}
            <Card>
                <Table minWidth="600px">
                    <thead><tr><Th>Role Name</Th><Th>Description</Th><Th>Permissions</Th><Th>Users</Th><Th>Actions</Th></tr></thead>
                    <tbody>
                        {roles?.map(role => (
                            <Tr key={role.id}>
                                <Td><div className="flex items-center gap-2"><ShieldCheckIcon className="w-4 h-4 text-emerald-700" /><span className="font-medium text-slate-800">{role.name}</span></div></Td>
                                <Td className="text-slate-500 text-sm">{role.description || '—'}</Td>
                                <Td><Badge variant="info">{role.permissions?.length || 0} permissions</Badge></Td>
                                <Td><Badge variant="neutral">{role.users_count || 0} users</Badge></Td>
                                <Td>
                                    <div className="flex items-center gap-1">
                                        <Link href={`/roles/${role.id}/edit`} className="p-1.5 hover:bg-slate-100 rounded-lg transition-colors"><PencilSquareIcon className="w-4 h-4 text-slate-500" /></Link>
                                        {role.name !== 'Admin' && <button onClick={() => setDeleteConfirm(role.id)} className="p-1.5 hover:bg-red-50 rounded-lg transition-colors"><TrashIcon className="w-4 h-4 text-red-400" /></button>}
                                    </div>
                                </Td>
                            </Tr>
                        ))}
                    </tbody>
                </Table>
                {(!roles || roles.length === 0) && <EmptyState icon={ShieldCheckIcon} title="No roles yet" description="Create roles to manage permissions." action={<Button href="/roles/create" size="sm"><PlusIcon className="w-4 h-4" /> Create Role</Button>} />}
            </Card>
            <Modal show={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} title="Delete Role" iconBg="bg-red-100" iconColor="text-red-600" icon={<TrashIcon className="w-5 h-5" />}>
                <ModalBody><p className="text-sm text-slate-600">Are you sure? Users with this role will need a new role assigned.</p></ModalBody>
                <ModalFooter><Button variant="outline" onClick={() => setDeleteConfirm(null)}>Cancel</Button><Button variant="danger" onClick={() => deleteRole(deleteConfirm)}>Delete</Button></ModalFooter>
            </Modal>
        </AppLayout>
    );
}
